(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-banner"] && !Shopify.designMode) return;
  try {
    
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};
DC.controllers['dc-section'] = DC.controllers['dc-section'] || function(root){};
(function(){
  const init = () => document.querySelectorAll('[data-controller="dc-section"]').forEach(el=>{
    if(!el.__dcInit){ el.__dcInit = true; DC.controllers['dc-section'](el); }
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-hero-slider"] && !Shopify.designMode) return;
  try {
    
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};

DC.controllers['dc-hero'] = (root) => {
  const track = root.querySelector('[data-track]');
  const slides = [...root.querySelectorAll('[data-slide]')];
  const dots = [...root.querySelectorAll('[data-dot]')];
  const prevBtn = root.querySelector('[data-prev]');
  const nextBtn = root.querySelector('[data-next]');

  const animateScale = root.dataset.animateScale === 'true';
  const autoplay = root.dataset.autoplay === 'true';
  const pauseHover = root.dataset.pauseHover === 'true';
  const intervalMs = parseInt(root.dataset.interval || '6000', 10);

  // timing var for CSS
  root.style.setProperty('--_interval', (intervalMs/1000)+'s');

  let index = 0, timer;

  function triggerScale(slide){
    if(!animateScale || !slide) return;
    const medias = slide.querySelectorAll('.dc-hero__media img, .dc-hero__video');
    medias.forEach(m=>{
      // Reset and start slightly zoomed, then animate down
      m.style.animation = 'none';
      m.style.transform = 'scale(1.035)';
      void m.offsetHeight; // reflow
      m.style.animation = `dcScaleDown ${intervalMs/1000}s ease-out forwards`;
    });
  }

  function update(i){
    index = (i + slides.length) % slides.length; // wrap for loop
    track.style.transform = `translateX(${index * -100}%)`;

    slides.forEach((s,idx)=>{
      s.toggleAttribute('data-active', idx===index);
    });

    // restart scale animation on active
    triggerScale(slides[index]);

    // reset dot progress
    dots.forEach((d,idx)=>{
      const fill = d.querySelector('.dc-hero__dot-fill');
      if(!fill) return;
      fill.style.transition='none';
      fill.style.width='0%';
      void fill.offsetWidth;
      if(idx===index && autoplay){
        fill.style.transition=`width ${intervalMs}ms linear`;
        fill.style.width='100%';
      }
    });
  }

  function next(){ update(index+1); restart(); }
  function prev(){ update(index-1); restart(); }

  function start(){
    if(!autoplay || slides.length < 2) return;
    stop();
    timer = setInterval(next, intervalMs);
  }
  function stop(){ if(timer) clearInterval(timer); }
  function restart(){ stop(); start(); }

  // Dots & arrows
  dots.forEach((d,i)=> d.addEventListener('click', ()=>{ update(i); restart(); }));
  prevBtn && prevBtn.addEventListener('click', prev);
  nextBtn && nextBtn.addEventListener('click', next);

  // Hover pause
  if (pauseHover){
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
  }

  // Touch swipe
  let startX = 0, dx = 0;
  track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; dx = 0; stop(); }, {passive:true});
  track.addEventListener('touchmove',  e => { dx = e.touches[0].clientX - startX; }, {passive:true});
  track.addEventListener('touchend',   () => { if (Math.abs(dx) > 50) { dx < 0 ? next() : prev(); } start(); });

  // Init
  update(0);
  start();
};

// Auto-init for this section
(function(){
  const init = () => document.querySelectorAll('[data-controller="dc-hero"]').forEach(el=>{
    if (!el.__dcInit){ el.__dcInit = true; DC.controllers['dc-hero'](el); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-product-tabs"] && !Shopify.designMode) return;
  try {
    
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};

DC.controllers['dc-product-tabs'] = (root) => {
  const btns = [...root.querySelectorAll('[data-tab-btn]')];
  const panels = [...root.querySelectorAll('[data-tab-panel]')];

  const activate = (idx) => {
    btns.forEach((b,i)=>{
      b.classList.toggle('is-active', i===idx);
      b.setAttribute('aria-selected', i===idx ? 'true' : 'false');
      panels[i]?.classList.toggle('is-active', i===idx);
    });
  };

  btns.forEach((b,i)=> b.addEventListener('click', ()=> activate(i)));

  // Keyboard a11y
  root.addEventListener('keydown', (e)=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
    const current = btns.findIndex(b => b.classList.contains('is-active'));
    let next = current;
    if(e.key==='ArrowRight') next = (current+1) % btns.length;
    if(e.key==='ArrowLeft')  next = (current-1+btns.length) % btns.length;
    if(e.key==='Home') next = 0;
    if(e.key==='End')  next = btns.length-1;
    btns[next].focus(); activate(next);
  });

  // Init
  activate(0);
};

// Auto-init
(function(){
  const init = () => document.querySelectorAll('[data-controller="dc-product-tabs"]').forEach(el=>{
    if(!el.__dcInit){ el.__dcInit = true; DC.controllers['dc-product-tabs'](el); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
